import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ChatService } from 'src/app/core/services/chat.service';

@Component({
  selector: 'app-imageviewmodal',
  templateUrl: './imageviewmodal.component.html',
  styleUrls: ['./imageviewmodal.component.scss']
})
export class ImageviewmodalComponent implements OnInit {

  @Input() public message;
  // @Input() public imagePathTemp;
  @Input() public imagePathTempParametrer;


  constructor(private activeModal: NgbActiveModal ,    private _spinner: NgxSpinnerService,
    private _chatService: ChatService,
    ) { }
    imagePathTemp:any
    isLoadSuccsess:boolean=false
    gie(){

    this._spinner.show()
    this._chatService.getPresignedUrl(this.imagePathTempParametrer).subscribe((resp) => {

      if (resp.success) {

        var  link = resp.data.presigned_url;
          this.imagePathTemp =link
          this._spinner.hide()
        //  console.log(link,"link orignal");
        this.isLoadSuccsess =true
      }
    });

  }

  ngOnInit() {

    this.gie()
  }

  closeDialog() {
    this.activeModal.close();
  }
}
